/**
 * ErrorCaptureWrapper — bridges AI Platform auth to Ops Center error reporting
 *
 * Place inside AuthProvider in App.tsx so user context is available.
 */

import { ErrorCaptureProvider } from './ErrorCaptureProvider';
import { ErrorBoundary } from './ErrorBoundary';
import { useAuth } from '../hooks/useAuth';
import type { ReactNode } from 'react';

const config = {
  apiBaseUrl: 'https://api-ops.jpthegeek.com',
  apiKey: import.meta.env.VITE_OPS_CENTER_API_KEY || '',
  platformId: 'aiplatform',
};

export default function ErrorCaptureWrapper({ children }: { children: ReactNode }) {
  const { user } = useAuth();

  return (
    <ErrorBoundary config={config}>
      <ErrorCaptureProvider
        config={config}
        user={user?.user ? { email: user.user.email || '', name: user.user.name || '' } : undefined}
      >
        {children}
      </ErrorCaptureProvider>
    </ErrorBoundary>
  );
}
